import React, { useState, useEffect, useContext } from 'react'
import ModalWindow from '../../layout/modalwindow/ModalWindow'
import ReactDOM from 'react-dom'
import RegisterCustomerAccountForm from './form/RegisterCustomerAccountForm'
import CustomersAccountsListHeader from './CustomersAccountsListHeader'
import CustomersAccountsListInner from './CustomersAccountsListInner'
import CustomersAccountsListFooter from './CustomersAccountsListFooter'
import { appContext } from '../../../App'
import { getCustomersAccountsList, deleteCustomerAccount, getCustomersAccountsSettings,
  saveCustomersAccountsSettings } from '../CustomersAccountsFunctions'

export const customersAccountsListControllerContext = React.createContext()

function CustomersAccountsListController(props) {
  const app = useContext(appContext)
  const [customersAccounts, setCustomersAccounts] = useState([])
  const [customersAccountsSorted, setCustomersAccountsSorted] = useState(false)
  const [customerSaved, setCustomerSaved] = useState(false)
  const [selectedCustomersAccount, setSelectedCustomersAccount] = useState([])
  const [selectAll, setSelectAll] = useState(false)
  const [foundEmptyCreditAccounts, setFoundEmptyCreditAccounts] = useState(null)

  // Footer Functions
  const [page, setPage] = useState(1)
  const [recordPerPage, setRecordPerPage] = useState(2)
  const [recPP, setRecPP] = useState(2)
  const [totalPage, setTotalPage] = useState(0)
  const [startSlice, setStartSlice] = useState(0)
  const [endSlice, setEndSlice] = useState(0)
  const [customersAccountsSettings, setCustomersAccountsSettings] = useState(null)

  // Filters
  const [sortByFilter, setSortByFilter] = useState({ sort_by: { date_time_created: -1 }})
  const [sortBy, setSortBy] = useState(null)

  const showRegisterCustomerAccountForm = (app, customerAccountID = null) => {
    // If find has result then it's an edit mode
    const cb = async (response) => {
      if (response === 'Save') { reloadCustomersAccountsList() }
    }
    const customerAccount = customersAccounts.find(customer_account => customer_account._id === customerAccountID)
    const registerCustomerAccountFormProps = { cb, app, customerAccount }

    ReactDOM.render(
      <ModalWindow
        id='mw-parent'
        width='45'
        header= { !customerAccount ? 'Create New Customer Account' : 'Edit ' + customerAccountID }
        footer={null}>
        <RegisterCustomerAccountForm { ...registerCustomerAccountFormProps } />
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const addSelectedCustomerAccount = (customerAccountID) => {
    setSelectedCustomersAccount([ ...selectedCustomersAccount, customerAccountID ])
  }

  const removeSelectedCustomerAccount = (customerAccountID) => {
    setSelectedCustomersAccount(selectedCustomersAccount.filter(customer_account_id => customer_account_id !== customerAccountID))
  }

  const deleteSelectedCustomersAccount = async () => {
    for (const customerAccountID of selectedCustomersAccount) {
      await deleteCustomerAccount(app, customerAccountID)
      removeSelectedCustomerAccount(customerAccountID)
    }
    //refreshCustomersAccountsList()
    reloadCustomersAccountsList()
    setAllCheck(false)
  }

  const getTotalCustomersAccountsRecord = () => customersAccounts.length

  const sortCustomersAccounts = (column) => {
    const sortByDateTimeCreated = () => {
      customersAccounts.sort((a, b) => {
        let sorted
        if (!customersAccountsSorted)
          sorted = ((new Date(a.date_time_created).getTime()) - (new Date(b.date_time_created).getTime()))
        else
          sorted = ((new Date(b.date_time_created).getTime()) - (new Date(a.date_time_created).getTime()))
        return sorted
      })
    }

    const sortById = () => {
      customersAccounts.sort((a, b) => {
        let x, y
        if (!customersAccountsSorted) {
          x = a._id.toLowerCase()
          y = b._id.toLowerCase()
        } else {
          x = b._id.toLowerCase()
          y = a._id.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    const sortByAccountName = () => {
      customersAccounts.sort((a, b) => {
        let x, y
        if (!customersAccountsSorted) {
          x = a.customer_details.account_name.toLowerCase()
          y = b.customer_details.account_name.toLowerCase()
        } else {
          x = b.customer_details.account_name.toLowerCase()
          y = a.customer_details.account_name.toLowerCase()
        }

        if (x < y) return -1
        if (x > y) return 1
        return 0
      })
    }

    const sortByTotalCreditAccounts = () => {
      customersAccounts.sort((a, b) => {
        let sorted
        if (!customersAccountsSorted)
          sorted = a.credit_accounts.length - b.credit_accounts.length
        else
          sorted = b.credit_accounts.length - a.credit_accounts.length
        return sorted
      })
    }

    const sortByCreditTotalAmount = () => {
      customersAccounts.sort((a, b) => {
        let sorted
        if (!customersAccountsSorted)
          sorted = a.credit_total_amount - b.credit_total_amount
        else
          sorted = b.credit_total_amount - a.credit_total_amount
        return sorted
      })
    }

    const sortByRemarks = () => {
      customersAccounts.sort((a, b) => {
        if (a.customer_details.remarks && b.customer_details.remarks) {
          let x, y
          if (!customersAccountsSorted) {
            x = a.customer_details.remarks.toLowerCase()
            y = b.customer_details.remarks.toLowerCase()
          } else {
            x = b.customer_details.remarks.toLowerCase()
            y = a.customer_details.remarks.toLowerCase()
          }

          if (x < y) return -1
          if (x > y) return 1
        }
        return 0
      })
    }

    switch(column) {
      case 'date_time_created': sortByDateTimeCreated()
      break

      case '_id': sortById()
      break

      case 'account_name': sortByAccountName()
      break

      case 'total_credit_accounts': sortByTotalCreditAccounts()
      break

      case 'credit_total_amount': sortByCreditTotalAmount()
      break

      case 'remarks': sortByRemarks()
      break

      default:
    }

    // This is just to force rerender of the view
    setCustomersAccountsSorted(!customersAccountsSorted)

    setCustomersAccounts(customersAccounts)
  }

  const filterCustomersAccounts = async (searchString) => {
    if (!searchString) { reloadCustomersAccountsList() }

    let tempCustomersAccounts = []

    customersAccounts.forEach(customer_account => {
      let found = true
      searchString.split(' ').forEach((search_string_item, i) => {
        found = (found && (customer_account.search_string.toLowerCase().search(search_string_item.toLowerCase()) !== -1))
      })
      if (found) tempCustomersAccounts.push(customer_account)
    })

    setAllCheck(false)
    setSelectAll(false)
    setCustomersAccounts(tempCustomersAccounts)
    setPage(1)
  }

  const setAllCheck = (check) => {
    const customerCheckBoxes = document.querySelectorAll('.customer-checkbox')
    let tempCAList = []

    // Clear the array of selected customer accounts
    // This is to ensure duplicate id's are avoided
    setSelectedCustomersAccount([])

    // First checked all checkbox that is not checked
    customerCheckBoxes.forEach((checkBox, i) => {
      const customerAccountID = checkBox.parentNode.parentNode.id

      if (check) tempCAList.push(customerAccountID)

      checkBox.checked = check
    })

    setSelectedCustomersAccount(tempCAList)
  }

  const reloadCustomersAccountsList = async () => {
    setRecordPerPage(customersAccountsSettings.footer.record_per_page)
    setRecPP(customersAccountsSettings.footer.record_per_page)

    const ca_list = await getCustomersAccountsList(app, { date: customersAccountsSettings.date, ...sortByFilter })

    setCustomersAccounts(ca_list)
    setFoundEmptyCreditAccounts(ca_list.find(customer_account => (customer_account.credit_accounts.length === 0)))
    setPage(1)
    setSortBy(null)
  }

  useEffect(() => {
    let isMounted = true

    const init = async () => {
      const ca_settings = await getCustomersAccountsSettings(app)
      if (isMounted) setCustomersAccountsSettings(ca_settings)
    }

    if (isMounted) init()

    return (() => { isMounted = false })
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (customersAccountsSettings) reloadCustomersAccountsList()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customersAccountsSettings])

  useEffect(() => {
    // set total page
    setTotalPage(Math.ceil(customersAccounts.length / recordPerPage))

    // slice stockinlist
    setStartSlice((page - 1) * recordPerPage)
    setEndSlice(page * recordPerPage)

    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordPerPage, page])

  const customersAccountsListController = {
    customerSaved: [customerSaved, setCustomerSaved],
    sortByFilter: [sortByFilter, setSortByFilter],
    page: [page, setPage],
    recPP: [recPP, setRecPP],
    recordPerPage: [recordPerPage, setRecordPerPage],
    startSlice: [startSlice, setStartSlice],
    endSlice: [endSlice, setEndSlice],
    selectAll: [selectAll, setSelectAll],
    sortBy: [sortBy, setSortBy],
    customersAccountsSettings: [customersAccountsSettings, setCustomersAccountsSettings],
    addSelectedCustomerAccount,
    removeSelectedCustomerAccount,
    setSelectedCustomersAccount,
    deleteSelectedCustomersAccount,
    selectedCustomersAccount,
    customersAccounts,
    getTotalCustomersAccountsRecord,
    totalPage,
    sortCustomersAccounts,
    customersAccountsSorted,
    filterCustomersAccounts,
    setAllCheck,
    foundEmptyCreditAccounts,
    showRegisterCustomerAccountForm,
    saveCustomersAccountsSettings,
    reloadCustomersAccountsList
  }

  return (
    <React.Fragment>
      <customersAccountsListControllerContext.Provider value={customersAccountsListController}>
        <CustomersAccountsListHeader />
        <CustomersAccountsListInner />
        <CustomersAccountsListFooter />
      </customersAccountsListControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(CustomersAccountsListController)